import { Button, message, Row } from 'antd';
import { useEffect, useState } from 'react';
import {convertCentsIntoDollar} from '../../../../helpers/genericHelper';
import API from '../../../../services/API';
import CustomText from '../../../CustomText';
import LoaderComponent from '../../../Loader';

function PreviewInvoiceComponent({ userId, subscriptionId }) {
    const [invoice, setInvoice] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadData(true);
    }, []);

    const loadData = async (reload) => {
        try {
            if (reload) {
                setLoading(true);
            }
            let res = await API.previewInvoice(userId, subscriptionId);
            setInvoice(res);
        } catch (e) {
            message.error(e.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="ant-list-box table-responsive" style={{ maxHeight: 400, background: 'white' }}>

            {loading && <LoaderComponent tip={'loading invoice'} />}
            <table className="width-100">
                <thead>
                <tr>
                    <th>Due Date</th>
                    <th>Amount Due</th>
                    <th>Amount Paid</th>
                    <th>Subtotal</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th>Subscription Start Date</th>
                    <th>Subscription End Date</th>
                </tr>
                </thead>
                <tbody>
                {invoice ? (
                    <tr>
                        <td>
                            {invoice.dueDate ? (
                                <CustomText dataSet={invoice} property1={'dueDate'} />
                            ) : (
                                <span>{'N/A'}</span>
                            )}
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'amountDueInCents'} formatter={convertCentsIntoDollar} />
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'amountPaidInCents'} formatter={convertCentsIntoDollar} />
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'subtotalInCents'} formatter={convertCentsIntoDollar}/>
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'taxInCents'} formatter={convertCentsIntoDollar} />
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'totalInCents'} formatter={convertCentsIntoDollar}/>
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'subscriptionPeriodStart'} />
                        </td>
                        <td>
                            <CustomText dataSet={invoice} property1={'subscriptionPeriodEnd'} />
                        </td>
                    </tr>
                ) : (
                    <tr>
                        <td colSpan="9">
                            <Row className="no-data-card">No invoice found</Row>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
}

export default PreviewInvoiceComponent;
